import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicHomePage from './components/PublicHomePage';
import SignUp from './components/SignUp';
import Login from './components/Login';
import PlayerDashboard from './components/PlayerDashboard';
import OrganizerDashboard from './components/OrganizerDashboard';
import PlayerProfile from './components/PlayerProfile';
import ViewTournament from './components/ViewTournament';
import HomePage from './components/HomePage';
import { PasswordResetRequest } from './components/PasswordResetRequest';
import { PasswordResetConfirm } from './components/PasswordResetConfirm';
import { MagicLinkLogin } from './components/MagicLinkLogin';
import CreateTournament from './components/CreateTournament';
import JoinTournament from './components/JoinTournament';
import TournamentDashboard from './components/TournamentDashboard';
import ManageTournament from './components/ManageTournament';
import OrganizerWaitlist from './components/OrganizerWaitlist';
import TestWhatsApp from './components/TestWhatsApp';
import './App.css';
import { DebugModeToggle } from './components/ErrorDisplay';

// Initialize Convex client
const convex = new ConvexReactClient(process.env.REACT_APP_CONVEX_URL!);

function App() {
  return (
    <ConvexProvider client={convex}>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <DebugModeToggle />
            <Routes>
              <Route path="/" element={<PublicHomePage />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<PasswordResetRequest />} />
              <Route path="/reset-password/:token" element={<PasswordResetConfirm />} />
              <Route path="/magic-link/:token" element={<MagicLinkLogin />} />
              <Route path="/dashboard/player" element={
                <ProtectedRoute>
                  <PlayerDashboard />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <PlayerProfile />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/organizer" element={
                <ProtectedRoute requiredRole="organizer">
                  <OrganizerDashboard />
                </ProtectedRoute>
              } />
              <Route path="/tournaments" element={<HomePage />} />
              <Route path="/create" element={
                <ProtectedRoute requiredRole="organizer">
                  <CreateTournament />
                </ProtectedRoute>
              } />
              <Route path="/join" element={<HomePage />} />
              <Route path="/join/:inviteCode" element={<JoinTournament />} />
              <Route path="/tournament/:inviteCode" element={<ViewTournament />} />
              <Route path="/dashboard/:tournamentId" element={
                <ProtectedRoute requiredRole="organizer">
                  <TournamentDashboard />
                </ProtectedRoute>
              } />
              <Route path="/manage/:tournamentId" element={
                <ProtectedRoute requiredRole="organizer">
                  <ManageTournament />
                </ProtectedRoute>
              } />
              <Route path="/organizer-waitlist" element={<OrganizerWaitlist />} />
              <Route path="/test-whatsapp" element={<TestWhatsApp />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ConvexProvider>
  );
}

export default App;
